import clsx from "clsx";
import s from "./style.module.scss";
import { messagesAtom } from "@/core/reatom/state/messages/messages";
import { useAtom } from "@reatom/npm-react";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { Icon28CopyOutline, Icon28ReplyOutline } from "@vkontakte/icons";
import { Reply } from "../Reply/Reply";
import { Files } from "@/core/reatom/state/currentService/currentService";
import { copyTextToClipboard } from "@telegram-apps/sdk-react";
import { Popover } from "@vkontakte/vkui";
import { MessageFiles } from "../MessageFiles/MessageFiles";
import { useState, useRef, useCallback } from "react";
//   type: "system" | "user" | "freelancer";
interface MessageProps {
  message: string;
  timestamp: number;
  senderId?: number;
  textType?: "html" | "raw";
  replyTo: number | null;
  setReplyed: () => void;
  isPending: boolean;
  id: number;
  files?: Files[];
}
dayjs.locale("ru");

export const Message = (props: MessageProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const messageRef = useRef<HTMLDivElement | null>(null);
  const holdTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleContextMenu = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setIsPopoverOpen(true);
  }, []);

  const handleTouchStart = useCallback(() => {
    holdTimeout.current = setTimeout(() => {
      setIsPopoverOpen(true);
    }, 200);
  }, []);

  const handleTouchEnd = useCallback(() => {
    if (holdTimeout.current) {
      clearTimeout(holdTimeout.current);
    }
  }, []);
  const [messages] = useAtom(messagesAtom);
  const {
    message,
    timestamp,
    senderId,
    textType = "raw",
    replyTo,
    isPending,
    setReplyed,
    id,
    files,
  } = props;
  const type =
    senderId === messages?.orders[0].author.id || isPending
      ? "user"
      : messages?.orders[0].arbitrators.find((el) => el.id === senderId)
      ? "system"
      : "freelancer";
  const avatar =
    type === "system"
      ? messages?.orders[0].arbitrators.find((el) => el.id === senderId)
          ?.photo_url
      : type === "freelancer"
      ? messages?.orders[0].freelancers.find((el) => el.id === senderId)
          ?.photo_url
      : "";
  const reply =
    messages?.replied_messages.find((el) => el.id === replyTo) ??
    messages?.items.find((el) => el.id === replyTo);
  const replyName =
    reply?.from_id == messages?.orders[0].author.id
      ? messages?.orders[0].author.full_name ??
        messages?.orders[0].author.username
      : messages?.orders[0].arbitrators.find((el) => el.id === reply?.from_id)
      ? messages?.orders[0].arbitrators.find((el) => el.id === reply?.from_id)
          ?.first_name
      : messages?.orders[0].freelancers[0].full_name;

  return (
    <div
      id={`${id}`}
      className={clsx(
        s.message,
        type === "user" && s.isUser,
        type === "freelancer" && s.isFreelancer,
        type === "system" && s.isSystem
      )}
    >
      {!(type === "user") && (
        <img
          src={avatar || "default-avatar.png"}
          alt="Аватар"
          className={s.avatar}
        />
      )}

      {isPopoverOpen && (
        <div className={s.backdrop} onClick={() => setIsPopoverOpen(false)} />
      )}
      <Popover
        noStyling
        trigger="manual"
        id="menupopup"
        role="dialog"
        aria-labelledby="menubutton"
        shown={isPopoverOpen}
        onShownChange={() => setIsPopoverOpen(false)}
        content={({ onClose }) => (
          <div className={s.popover}>
            <button
              className={s.buttons}
              role="menuitem"
              onClick={() => {
                if (!isPending) {
                  setReplyed();
                }
                onClose();
              }}
            >
              <p className={s.popoverText}>Ответить</p>
              <Icon28ReplyOutline
                className={clsx(s.icons, s.iconReply)}
                width={22}
                height={22}
              />
            </button>
            <hr className={s.hr} />
            <button
              className={s.buttons}
              role="menuitem"
              onClick={async () => {
                await copyTextToClipboard(message);
                onClose();
              }}
            >
              <p className={s.popoverText}>Скопировать</p>
              <Icon28CopyOutline
                className={clsx(s.icons)}
                width={22}
                height={22}
              />
            </button>
          </div>
        )}
      >
        <div
          className={s.content}
          ref={messageRef}
          onContextMenu={handleContextMenu}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          style={{
            zIndex: isPopoverOpen ? 11 : 0,
          }}
        >
          <div className={s.messageText}>
            {(reply?.text || !!reply?.files.length) && (
              <Reply
                replyName={replyName}
                replyTextShort={reply?.text}
                files={reply?.files}
                // onClick={scrollToMessage}
              />
            )}

            <div className={s.downloads}>
              {files &&
                files.map((file) => <MessageFiles file={file} key={file.id} />)}
            </div>

            {textType === "html" ? (
              <div
                dangerouslySetInnerHTML={{ __html: message }}
                className={s.htmlMessage}
              />
            ) : (
              message
            )}
          </div>
          <div
            className={clsx(
              s.messageTime,
              type === "user" && s.isUser,
              type === "freelancer" && s.isFreelancer,
              type === "system" && s.isSystem
            )}
          >
            {dayjs(timestamp).format("HH:mm")}
          </div>
        </div>
      </Popover>
    </div>
  );
};
